<section
  class="flex w-full flex-col items-center justify-start gap-2 bg-gradient-to-r from-[#0b254e] to-[#154fa0] px-4 py-6 text-white sm:flex-row md:px-2 lg:px-4"
  aria-labelledby="services-dashboard-summary-heading"
  [attr.aria-busy]="isLoading()"
>
  <h2 id="services-dashboard-summary-heading" class="sr-only">
    Services summary
  </h2>

  @if (isLoading()) {
    <div
      class="flex w-full flex-wrap items-center gap-5 sm:flex-nowrap sm:gap-12"
      role="status"
      aria-label="Loading services summary"
    >
      <div class="min-w-0 flex-1 animate-pulse self-center sm:max-w-200">
        <div class="flex flex-col items-center gap-3 pb-7">
          <div class="h-16 w-48 rounded bg-white/10 sm:h-20 sm:w-64"></div>
          <div class="h-5 w-52 rounded bg-white/10"></div>
        </div>
        <div class="h-12 w-full rounded-md bg-white/10"></div>
      </div>

      <div
        class="hidden h-50 w-125 shrink-0 animate-pulse items-center justify-center gap-6 self-center md:flex xl:w-auto"
      >
        <div
          class="h-40 w-40 shrink-0 rounded-full border-20 border-white/10"
        ></div>
        <div class="flex min-w-0 flex-1 flex-col gap-2.5">
          @for (item of [1, 2, 3, 4, 5]; track item) {
            <div class="h-4 w-28 rounded bg-white/10"></div>
          }
        </div>
      </div>
    </div>
    <span class="sr-only">Loading services summary…</span>
  } @else {
    <div class="w-full min-w-0 sm:flex-1 sm:self-center">
      <div class="flex flex-col items-center pb-7 uppercase">
        <div class="flex items-center text-white">
          <div class="text-6xl leading-tight text-white lg:text-7xl">
            {{ totalServices() }}
          </div>
          <div class="pt-2 pl-3 text-white sm:pl-4">
            <span
              class="font-montserrat text-sm leading-tight font-bold tracking-wider text-white lg:text-lg"
              >Total Active</span
            >
            <span
              class="font-lato -mt-2 flex text-4xl leading-tight font-light normal-case lg:text-5xl"
              >Services</span
            >
          </div>
        </div>
        <div
          class="text-center text-lg leading-6 font-semibold tracking-wide text-white lg:text-2xl"
        >
          Spanning {{ totalLocations() ?? 0 }} locations
        </div>
      </div>

      <app-service-progress-bar
        [inService]="inServiceServices()"
        [pending]="pendingServices()"
      ></app-service-progress-bar>
    </div>

    <div
      class="flex min-w-0 flex-col items-center justify-center gap-2 sm:flex-1 sm:self-center xl:flex-row"
    >
      <app-service-type-chart
        [data]="serviceTypeObject()"
        class="hidden w-full min-w-0 justify-center sm:flex"
      ></app-service-type-chart>

      @if (hasBandwidthData()) {
        <div
          class="flex w-full shrink-0 flex-col items-center gap-1 text-center md:ml-auto md:w-auto md:items-start md:self-end md:text-left"
          *ngxPermissionsOnly="Permission.NITEL_IQ_PARTICIPANT"
        >
          <a
            routerLink="/services/p95-utilization"
            class="font-lato flex items-center gap-1 text-sm font-semibold text-white hover:underline"
            aria-label="View 95th percentile bandwidth utilization report"
          >
            View 95th percentile report
            <mat-icon
              class="flex! h-4! w-4! items-center! justify-center! text-base!"
              aria-hidden="true"
              >arrow_forward</mat-icon
            >
          </a>
          <p class="font-lato text-xs text-white/50">
            Monitor peak bandwidth across your network
          </p>
        </div>
      }
    </div>
  }
</section>
